import React from "react";
import { faCode, faLaptopCode, faRectangleAd, faMicrochip, faWandMagicSparkles, faNetworkWired, faAngleDoubleRight  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FadeSection from "./utils/anim";
import { CardEffect } from "./ui/card-effect";

const ServiceCard = ({ icon, title, description ,more, classes, lightMode }) => (
    <CardEffect className={`"hover:shadow-md" ${lightMode ? "rounded-2xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.40)]":"shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]"}`}>
    <div className={`rounded-2xl p-6 ${classes} transition-shadow`}>
       <FadeSection effect="fade-in-down">
      <div className="text-pink-500 mb-4">
        {icon}
      </div>
      <h3 className="text-gray-800 text-left font-medium text-lg mb-2">{title}</h3>
      <p className="text-gray-600 text-left font-semibold text-sm leading-relaxed">{description}</p>
      {more && <button className="third-color mt-2">Read More <FontAwesomeIcon icon={faAngleDoubleRight} /></button> }
      </FadeSection>
    </div>
    </CardEffect>
  );


function WhatIDo({ lightMode }){

    const services = [
        {
          icon: (<FontAwesomeIcon className="pl-2 third-color size-7 text-white" size="1x" icon={faCode} /> ),
          title: "Website Development",
          description: "Create stunning , user-friendly and responsive website for you based on your idea, that can be of any industries.",
          readMore : false
        },
        {
          icon: (<FontAwesomeIcon className="pl-2 third-color size-7 text-white" icon={faLaptopCode} /> ),
          title: "Web Application Development",
          description: "You bring up with the idea to create a application and i make it happen. It will be Functional, Practical and Colorful.",
          readMore : false
        },
        {
          icon: (<FontAwesomeIcon className="pl-2 third-color size-7 text-white" size="1x" icon={faMicrochip} />   ),
          title: "Robotic Process Automation Development",
          description: "Let's make AI Work for you. I use RPA process to build work flows that reduce your daily work process.",
          readMore : false
        },
        {
          icon: (<FontAwesomeIcon className="pl-2 third-color size-7 text-white" size="1x" icon={faRectangleAd} /> ),
          title: "SEO Optimisation",
          description: "Your website ranking matters. Boost your online visibility and drive more organic traffic with our expert SEO optimization services.",
          readMore : false
        },
        {
          icon: (<FontAwesomeIcon className="pl-2 third-color size-7 text-white" size="1x" icon={faNetworkWired} />  ),
          title: "API Integration",
          description: "Deal with third party software / application to integrate with your software/website using API's includes Payment Gateway, CRM, ERP integrations. ",
          readMore : false
        },
        {
          icon: (<FontAwesomeIcon className="pl-2 third-color size-7 text-white" size="1x" icon={faWandMagicSparkles} /> ),
          title: "UX/UI Design",
          description: "Having best UI element in the application makes the best UX. I create Awesome, meaningful and powerfull UI that suits for your application. ",
          readMore : false
        },
      ];

    return(
        <>
        <div className="mx-auto min-h-full py-16 px-4">
        <div className="max-w-7xl mx-auto">
        <FadeSection effect="fade-right">
          {/* <div className="third-color text-left uppercase text-sm font-medium mb-2">SERVICES</div> */} 
          <h2 className={`text-4xl text-left font-bold ${lightMode ? "service-title-light":"service-title"} text-white mb-12`}>What I Do</h2>
        </FadeSection>
        <div className="flex justify-center">
          <div className="text-left max-w-6xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                icon={service.icon}
                title={service.title}
                description={service.description}
                more={service.readMore}
                lightMode={lightMode}
                classes=""
              />
            ))}
          </div>
        </div>
      </div>
    </div>  
        </>
    );
}


export default WhatIDo;